import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { PageTitle, Panel, Btn } from "@/admin/ui";

export default function Versions() {
  const [d, setD] = useState({ versions: [], active_version: null });
  const [note, setNote] = useState("");
  const load = () => api.get("/admin/versions").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const publish = async () => {
    try { const r = await api.post("/admin/versions/publish", { note }); toast.success(`Published version ${r.data.version}`); setNote(""); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const activate = async (v) => {
    try { await api.post(`/admin/versions/${v}/activate`); toast.success(`Version ${v} is now active`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6">
      <PageTitle title="Ruleset Versions" sub="Publishing snapshots all approved rules and reconciliation groups. It requires commercial-use authorisation on every rule and a full golden-test pass. Customer reports always use the active version." />
      <Panel title="Publish draft" testId="publish-panel">
        <div className="flex flex-wrap gap-2">
          <Input placeholder="Change note" value={note} onChange={(e) => setNote(e.target.value)} className="max-w-md" data-testid="publish-note-input" />
          <Btn onClick={publish} data-testid="publish-btn">Publish new version</Btn>
        </div>
      </Panel>
      <Panel title="History" testId="versions-list">
        <p className="mb-3 text-sm">Active version: <strong data-testid="active-version">{d.active_version ?? "none"}</strong></p>
        <ul className="divide-y divide-border text-sm">
          {d.versions.map((v) => (
            <li key={v.version} className="flex flex-wrap items-center justify-between gap-2 py-3">
              <span>v{v.version} · {v.rule_count} rules · {v.group_count} groups · {v.published_at.slice(0, 16).replace("T", " ")} · {v.published_by} <span className="text-muted-foreground">{v.note}</span></span>
              {v.version !== d.active_version && <Btn variant="ghost" onClick={() => activate(v.version)} data-testid={`activate-version-${v.version}`}>Roll back to this</Btn>}
            </li>
          ))}
          {!d.versions.length && <li className="py-3 text-muted-foreground">Nothing published yet.</li>}
        </ul>
      </Panel>
    </div>
  );
}
